module.exports = "/_next/static/images/115d505d5d845a436bc187869b38171f-requirements-xs.jpg.webp";